<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_placeholder_inspection_apply_keyword') ||
                  '验货需求单号/下单客户名称/客户PO#/验货工厂 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              v-if="allow('A')"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditPage', { pageType: 'add' })"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" label-width="110px" size="small">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_applyStatus') || '申请单状态'">
              <dict-select
                v-model="form.applyStatusList"
                url="/sys/common/dict/system"
                :body="applyStatusParams"
                :placeholder="
                  $l('form_placeholder_applyStatus') || '请选择申请单状态'
                "
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_applyNo') || '验货需求单号'">
              <el-input
                v-model.trim="form.applyNo"
                clearable
                :placeholder="
                  $l('form_placeholder_applyNo') || '请输入验货需求单号'
                "
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_applyUserName') || '申请人'">
              <dict-select
                v-model="form.applyUserCodeList"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('form_placeholder_applyUserName') || '请选择申请人'
                "
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('form_label_applyDate') || '申请日期'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.applyDateStart"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                    :placeholder="
                      $l('form_placeholder_applyDateStart') || '请选择开始日期'
                    "
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.applyDateEnd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                    :placeholder="
                      $l('form_placeholder_applyDateEnd') || '请选择结束日期'
                    "
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_urgencyLevel') || '紧急程度'">
              <dict-select
                v-model="form.urgencyLevelList"
                url="/sys/common/dict/system"
                :body="urgencyLevelParams"
                :placeholder="
                  $l('form_placeholder_urgencyLevel') || '请选择紧急程度'
                "
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_inspectionResult') || '验货结果'">
              <dict-select
                v-model="form.inspectionResultList"
                url="/sys/common/dict/system"
                :body="inspectionResultParams"
                :placeholder="
                  $l('form_placeholder_inspectionResult') || '请选择验货结果'
                "
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_customerCode') || '客户'">
              <el-select
                v-model="form.customerCodeList"
                :placeholder="$l('form_placeholder_customerCode') || '请选择客户'"
                filterable
                multiple
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in customerOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_orderNos') || '客户PO#'">
              <el-input
                v-model.trim="form.orderNos"
                clearable
                :placeholder="$l('form_placeholder_orderNos') || '请输入客户PO#'"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('form_label_deliveryDeadline') || '订单交期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.deliveryDeadlineStart"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                    :placeholder="
                      $l('form_placeholder_deliveryDeadlineStart') ||
                        '请选择开始日期'
                    "
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.deliveryDeadlineEnd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                    :placeholder="
                      $l('form_placeholder_deliveryDeadlineEnd') ||
                        '请选择结束日期'
                    "
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_productName') || '品名'">
              <el-input
                v-model.trim="form.productName"
                clearable
                :placeholder="$l('form_placeholder_productName') || '请输入品名'"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('form_label_inspectionStartTime') || '验货开始日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.inspectionStartTime"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                    :placeholder="
                      $l('form_placeholder_inspectionStartTime') ||
                        '请选择验货开始日期'
                    "
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.inspectionEndTime"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                    :placeholder="
                      $l('form_placeholder_inspectionEndTime') ||
                        '请选择验货结束日期'
                    "
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_inspectionFactory') || '验货工厂'"
            >
              <el-input
                v-model.trim="form.inspectionFactory"
                clearable
                :placeholder="
                  $l('form_placeholder_inspectionFactory') || '请输入验货工厂'
                "
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_inspectionAddress') || '验货详细地址'"
            >
              <el-input
                v-model.trim="form.inspectionAddress"
                clearable
                :placeholder="
                  $l('form_placeholder_inspectionAddress') ||
                    '请输入验货详细地址'
                "
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_applyReason') || '申请事由'">
              <el-input
                v-model.trim="form.applyReason"
                clearable
                :placeholder="
                  $l('form_placeholder_applyReason') || '请输入申请事由'
                "
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { request } from '@/api/service'

const initForm = {
  keyword: '',
  applyStatusList: [],
  applyNo: '',
  applyUserCodeList: [],
  applyDateStart: '',
  applyDateEnd: '',
  urgencyLevelList: [],
  inspectionResultList: [],
  applyReason: '',
  customerCodeList: [],
  orderNos: '',
  deliveryDeadlineStart: '',
  deliveryDeadlineEnd: '',
  inspectionStartTime: '',
  inspectionEndTime: '',
  inspectionFactory: '',
  inspectionAddress: '',
  productName: '',
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      customerOptions: [],
      applyStatusParams: { dictType: 'DF_INSPECTION_APPLY_STATUS' },
      inspectionResultParams: { dictType: 'DF_INSPECTION_APPLY_RESULT' },
      urgencyLevelParams: { dictType: 'DF_INSPECTION_APPLY_URGENCY_LEVEL' },
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
    this.getCust()
  },
  methods: {
    getCust() {
      request({
        url: '/digitalCenter/common/dict/customer',
        method: 'post',
        data: {},
      }).then((res) => {
        this.customerOptions = (res.body && res.body.data) || []
        if (this.customerOptions && this.customerOptions.length) {
          this.customerOptions.splice(0, 0, { label: 'ALL', value: 'ALL' })
        } else {
          this.customerOptions = [{ label: 'ALL', value: 'ALL' }]
        }
      })
    },
    query({ isReset = true } = {}) {
      if (isReset) this.$emit('reset')
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>

